import { IsomorphicContainer } from '@gasbuddy/react';

export default class OfferContainer extends IsomorphicContainer {
  constructor(initialState) {
    super(initialState, 'Offer');
  }
}
